import { render, staticRenderFns } from "./JobRequirements.vue?vue&type=template&id=ba33f7fa&scoped=true&"
import script from "./JobRequirements.vue?vue&type=script&lang=js&"
export * from "./JobRequirements.vue?vue&type=script&lang=js&"
import style0 from "./JobRequirements.vue?vue&type=style&index=0&id=ba33f7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba33f7fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFileInput,VForm,VIcon,VSelect,VTextField})
